import styled from 'styled-components';
import '../../styles/GlobalThemeStyleCQ';
import {
	Card,
	Table,
	Button,
	Modal,
	List,
	Avatar,
	Dropdown,
	Badge,
	Radio,
	Progress,
	Segmented,
	Select,
	Space,
} from 'antd';
import Lottie from 'lottie-react';
import ReactSpeedometer from 'react-d3-speedometer';

export const XTheme2Para1 = styled.p`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.themeColor3};
`;
export const XTheme2Title2 = styled.h2`
	margin: 0px;
	font-weight: 600;
	font-size: 14px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.themeColor2};
	span {
		font-weight: 400;
		font-size: 12px;
		line-height: 16px;
	}
`;
export const XTheme2Card = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	box-shadow: none;
	padding: 0;
	.ant-card {
		border: 1px solid ${({ theme }) => theme.CQColors.themeColor4};
		border-radius: 10px;
		.ant-avatar {
			background: ${({ theme }) => theme.CQColors.themeColor1} !important;
		}
	}
	.ant-card-head {
		border: none;
		min-height: auto;
		margin-top: 15px;
		.ant-card-head-title {
			font-weight: 600;
			font-size: 16px;
			line-height: 24px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
		}
	}
	&.gradientCard {
		background: #fff url(../images/gradient-image.svg) no-repeat top center !important;
		background-size: cover !important;
	}
	.payerLogo {
		border-radius: 10px;
		width: 60px;
		max-width: 120px;
		height: 40px;
		margin: 0px auto;
		line-height: 40px;
		background: ${({ theme }) => theme.CQColors.bodyBg};
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		font-size: 14px;
		font-weight: 600;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}
	.payerName {
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}

	&.noPadding {
		.ant-card-body {
			padding: 24px 0px !important;
		}
	}
	.hasPadding {
		padding: 0px 24px !important;
	}
	.title {
		width: 100%;
		position: relative;
		margin: 15px 0px;
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		text-transform: capitalize;
		&.largeTitle {
			margin: 10px 0px;
			font-size: 16px;
			line-height: 100%;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
		&.smallTitle {
			margin: 0px;
			font-size: 12px;
			font-weight: 500;
			line-height: 100%;
			color: ${({ theme }) => theme.CQColors.themeColor3};
		}
	}
`;
export const XTheme2AvatarListCard = styled(Avatar)`
	font-weight: 600;
	font-size: 16px;
	line-height: 26px;
	border-radius: 10px !important;
	margin-top: 6px;
	min-width: 80px !important;
	min-height: 50px !important;
	&.color1 {
		background: #f9f9f9 !important;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		border: 1px solid #f0f0f0 !important;
	}
	&.color2 {
		background: #f9f9f9 !important;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		border: 1px solid #f0f0f0 !important;
	}
	&.color3 {
		background: #f9f9f9 !important;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		border: 1px solid #f0f0f0 !important;
	}
`;
export const XTheme2ListCard = styled(List)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.CQColors.white};
	.ant-list-item {
		background: #ffffff;
		border: 1px solid #f0f0f0;
		border-radius: 10px;
		padding: 10px;
		margin-bottom: 10px;
		&:last-child {
			border-bottom: 1px solid #f0f0f0;
		}
		.buttonWrapper {
			@media (max-width: 575.99px) {
				width: 100%;
				button {
					width: 100%;
					margin-top: 10px;
					padding: 0px 10px;
					height: 34px;
				}
			}
		}
		.ant-list-item-meta-content {
			margin-top: 5px;
			.ant-list-item-meta-title {
				font-weight: 500;
				font-size: 14px;
				line-height: 26px;
				color: ${({ theme }) => theme.CQColors.themeColor2};
			}
			.ant-list-item-meta-description {
				font-weight: 400;
				font-size: 12px;
				line-height: 16px;
				color: ${({ theme }) => theme.CQColors.themeColor3};
			}
		}
	}
`;
export const XTheme2ListBtn = styled(Button)`
	border-radius: 10px;
	font-weight: 600;
	font-size: 14px;
	line-height: 26px;
	min-width: 100px;
	text-align: center;
	&.color1 {
		background: rgba(190, 18, 60, 0.1) !important;
		color: #be123c;
		border: 1px solid rgba(190, 18, 60, 0.1) !important;
		&:hover {
			color: #be123c !important;
		}
	}
	&.color2 {
		background: rgba(255, 115, 22, 0.1) !important;
		color: #f97316;
		border: 1px solid rgba(249, 115, 22, 0.1) !important;
		&:hover {
			color: #f97316 !important;
		}
	}
	&.color3 {
		background: rgba(220, 138, 4, 0.1) !important;
		color: #ca8a04;
		border: 1px solid rgba(202, 138, 4, 0.1) !important;
		&:hover {
			color: #ca8a04 !important;
		}
	}
`;
export const XTheme2ChatBox = styled.div`
	width: 100%;
	position: relative;
	background: transparent;
`;
export const XTheme2Refresh = styled(Button)`
	font-weight: 600;
	font-size: 14px;
	line-height: 22px;
	text-align: right;
	color: ${({ theme }) => theme.CQColors.themeColor1};
	&:hover {
		background: transparent !important;
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
	}
`;
export const XTheme2InnerCard = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 10px;
	@media (max-width: 768.99px) {
		&.withBackground {
			background: ${({ theme }) => theme.CQColors.white};
			border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		}
		background: transparent;
		border: none;
	}
	.ant-card-body {
		padding: 20px;
	}
	.insideCard {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		&.borderRight {
			border-right: 1px solid ${({ theme }) => theme.CQColors.borderColor};
			@media (max-width: 768.99px) {
				border-right: none;
			}
		}
		.imgWrapper {
			width: 60px;
			position: relative;
			text-align: right;
			margin-right: 15px;
		}
		.textWrapper {
			width: calc(100% - 60px);
			span.title {
				margin: 0px;
				font-weight: 400;
				font-size: 14px;
				line-height: 14px;
				color: ${({ theme }) => theme.CQColors.primaryColor};
			}
			.numberWrapper {
				font-weight: 600;
				font-size: 24px;
				line-height: 30px;
				color: ${({ theme }) => theme.CQColors.primaryColor};
				sub {
					font-size: 14px;
					line-height: 14px;
					color: #169166;
				}
			}
		}
	}
	.avatarTextWrapper {
		width: calc(100% - 70px);
		display: flex;
		align-items: center;
		float: left;
		.avatarImg {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			margin-right: 10px;
			background: ${({ theme }) => theme.CQColors.themeColor4};
		}
		.avatarText {
			width: calc(100% - 60px);
			font-weight: 600;
			font-size: 16px;
			line-height: 20px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
			span {
				font-weight: 500;
				font-size: 14px;
				line-height: 16px;
				color: #71717a;
			}
		}
	}
	.avatarTexDropDown {
		width: 70px;
		float: right;
		text-align: right;
		align-items: center;
		margin-top: 10px;
		button {
			display: block;
			height: 100%;
			float: right;
			background: #fff;
			border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
			svg {
				font-weight: 600;
				font-size: 20px;
			}
			&:hover {
				background: linear-gradient(
					270deg,
					#169191 0%,
					#82c446 100%
				) !important;
				color: ${({ theme }) => theme.CQColors.white} !important;
				border-color: ${({ theme }) =>
					theme.CQColors.themeColor1} !important;
			}
		}
	}
	.cursorPointer {
		cursor: pointer;
	}
`;
export const XTheme2DropdownStatus = styled(Dropdown)`
	background: transparent !important;
	border: none !important;
	svg {
		background: #71717a;
		border-radius: 50%;
		padding: 2px;
		font-size: 14px;
		color: ${({ theme }) => theme.CQColors.white};
	}
	.ant-dropdown-menu {
		border-radius: 0px;
		box-shadow: none;
		border: none;
	}
`;
export const XTheme2Badge = styled(Badge)`
	.ant-badge-dot {
		background-color: #61af4a;
		top: 10px;
		right: 7px;
	}
`;
export const XTheme2Progress = styled(Progress)`
	.ant-progress-text {
		font-weight: 600 !important;
		font-size: 14px !important;
		line-height: 22px !important;
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
	}
	.ant-progress-text {
		font-weight: 700;
		font-size: 14px;
		line-height: 17px;
		color: #169191;
	}
	.ant-progress-inner {
		position: relative;
	}
	.subHeading {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 1;
		.percentValue {
			color: ${({ theme }) => theme.CQColors.themeColor1};
			font-weight: 700;
			font-size: 14px;
			line-height: 14px;
			margin-bottom: 10px;
		}
		.subHeadingText {
			font-weight: 500;
			font-size: 12px;
			line-height: 14px;
			color: ${({ theme }) => theme.CQColors.themeColor3};
			opacity: 0.5;
		}
	}
`;
export const XTheme2TextButton = styled(Button)`
	background: transparent;
	border: none;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	box-shadow: none;
	font-weight: 600;
	font-size: 12px;
	line-height: 14px;
	&:hover {
		background: transparent !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
`;
export const XTheme2Segmented = styled(Segmented)`
	.ant-segmented-group {
		background: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
		border-radius: 8px !important;
		.ant-segmented-item {
			padding: 0px 10px;
			font-size: 12px;
			line-height: 20px;
			text-align: center;
			color: ${({ theme }) => theme.CQColors.themeColor1};
			&.ant-segmented-item-selected {
				background: linear-gradient(
					270deg,
					#169191 0%,
					#82c446 100%
				) !important;
				box-shadow: 0px 0px 2px rgba(0, 107, 185, 0.15) !important;
				border-radius: 8px !important;
				color: ${({ theme }) => theme.CQColors.white} !important;
			}
			&:hover {
				background: transparent !important;
				color: ${({ theme }) => theme.CQColors.themeColor1} !important;
			}
		}
	}
`;
export const XTheme2CustomSelect = styled(Select)`
	min-width: 110px;
	text-align: left;
	&.ant-select-single {
		height: 28px !important;
	}
	.ant-select-selector {
		background: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
		box-shadow: 0px 0px 34px -10px rgba(0, 107, 185, 0.15) !important;
		color: ${({ theme }) => theme.colors.themeColor2} !important;
	}
	.ant-select-selector {
		height: 28px !important;
		border-radius: 10px !important;
		line-height: 28px !important;
		font-size: 12px !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
	}
	&.customColor {
		.ant-select-selection-item {
			color: ${({ theme }) => theme.CQColors.themeColor1} !important;
		}
	}

	.ant-select-selection-item {
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
	}
`;
export const XTheme2InsurancePayerCard = styled(Card)`
	background: ${({ theme }) => theme.CQColors.white} !important;
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
	border-radius: 10px !important;
	.ant-card-body {
		padding: 10px 15px;
	}
	.payerLogo {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: rgba(224, 230, 236, 0.5);
		color: ${({ theme }) => theme.CQColors.primaryColor};
		box-shadow: inset 0px 16.8313px 16.8313px rgba(255, 255, 255, 0.8) !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		font-weight: 500;
		font-size: 12px;
		line-height: 40px;
		position: relative;
		text-align: center;
	}
	.payerName {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		padding: 10px 0px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		span {
			font-weight: 500;
			margin-left: 5px;
		}
	}
	.payerBorder {
		border-right: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		height: 100%;
		@media (max-width: 768.99px) {
			border-right: none;
		}
	}
	.tagStatus {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		span {
			display: inline-block;
			width: 10px !important;
			height: 10px !important;
			border-radius: 50%;
			line-height: 10px;
			&.color1 {
				background: #61af4a;
			}
			&.color2 {
				background: #ca8a04;
			}
			&.color3 {
				background: #be123c;
			}
		}
		em.color1 {
			margin: 0px 5px;
			color: #61af4a;
			font-style: normal;
		}
		em.color2 {
			margin: 0px 5px;
			color: #ca8a04;
			font-style: normal;
		}
		em.color3 {
			margin: 0px 5px;
			color: #be123c;
			font-style: normal;
		}
	}
`;
export const XTheme2InsuranceSpace = styled(Space)`
	@media (max-width: 1250.99px) {
		width: 100%;
		overflow-x: scroll;
		white-space: nowrap;
		&::-webkit-scrollbar {
			display: none;
		}
	}
`;
export const XTheme2ViewMoreListCard = styled.div`
	width: 100%;
	position: relative;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	text-align: left;
	color: ${({ theme }) => theme.CQColors.themeColor2};
	border-bottom: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	padding: 10px 0px;
	margin: 5px 0px;
	svg {
		margin-left: 10px;
		color: ${({ theme }) => theme.CQColors.themeColor6};
	}
	.fixedMoreValue {
		position: absolute;
		right: 0px;
		top: 10px;
		font-weight: 600;
		font-size: 12px;
		line-height: 16px;
	}
	.cardListTitle {
		text-align: left;
		font-weight: 500;
		font-size: 14px;
		line-height: 14px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.list2Color1 {
		color: ${({ theme }) => theme.colors.themeColor14};
	}
	.list2Color2 {
		color: ${({ theme }) => theme.colors.themeColor15};
	}
	.list2Color3 {
		color: ${({ theme }) => theme.colors.themeColor16};
	}
	.list2Color4 {
		color: ${({ theme }) => theme.colors.themeColor17};
	}
	@media (max-width: 575.99px) {
	}
`;
export const XTheme2ViewMoreTitle = styled.div`
	width: 100%;
	position: relative;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	text-align: left;
	color: ${({ theme }) => theme.CQColors.themeColor2};
`;
export const XTheme2ViewMorePending = styled(Card)`
	width: 100%;
	position: relative;
	background: #f9f9f9 !important;
	border: none !important;
	border-radius: 10px;
	margin-top: 15px;
	.titleCard {
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
		text-align: left;
		margin-bottom: 15px;
		padding-left: 15px;
	}
	&.noPadding {
		.ant-card-body {
			padding-top: 15px !important;
			padding-bottom: 15px !important;
		}
	}
	ul {
		list-style: none;
		padding: 0px 15px !important;
		margin: 0px;
		li {
			font-weight: 400;
			font-size: 12px;
			line-height: 14px;
			text-align: left;
			color: ${({ theme }) => theme.CQColors.primaryColor};
			border-bottom: 1px solid
				${({ theme }) => theme.CQColors.borderColor};
			padding: 15px 0px;
			clear: both;
			&:first-child {
				padding-top: 0px;
			}
			&:last-child {
				border-bottom: none;
				padding-bottom: 0px;
			}
			em {
				font-style: normal;
				font-weight: 500;
				font-size: 12px;
				line-height: 16px;
				color: ${({ theme }) => theme.CQColors.primaryColor};
				margin-right: 5px;
				background: ${({ theme }) => theme.CQColors.white};
				padding: 3px 10px;
				border-radius: 10px;
				&.year {
					color: ${({ theme }) => theme.CQColors.secondaryColor};
				}
			}
			span {
				margin-top: -5px;
				background: ${({ theme }) => theme.CQColors.white};
				border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
				border-radius: 36px;
				float: right;
				font-weight: 500;
				font-size: 12px;
				line-height: 12px;
				padding: 5px 10px;
				min-width: 60px;
				text-align: center;
				color: ${({ theme }) => theme.CQColors.primaryColor};
				&.doller {
					color: ${({ theme }) => theme.CQColors.secondaryColor};
				}
			}
		}
	}
`;
export const XThemeDashboardLottieCard = styled(Lottie)`
	width: 120px;
	position: relative;
	margin: 0px auto;
	background: transparent !important;
	text-align: center;
	&.caseManagementTitleAnimation {
		max-width: 80px;
		margin: 0px auto;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XTheme2ListNumber = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	border-radius: 10px;
	font-size: 14px;
	line-height: 26px;
	width: 100px;
	text-align: center;
	padding: 5px 10px;
	font-weight: 500;
	background: rgba(190, 18, 60, 0.1) !important;
	color: #be123c;
	border: 1px solid rgba(190, 18, 60, 0.1) !important;
	float: right;
	&:hover {
		color: #be123c !important;
	}
`;
export const XTheme2ReclaimCard = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	box-shadow: none;
	padding: 0;
	.ant-card {
		border: 1px solid ${({ theme }) => theme.CQColors.themeColor4};
		border-radius: 10px;
		.ant-avatar {
			background: ${({ theme }) => theme.CQColors.themeColor1} !important;
		}
	}
	.numberBox {
		border-radius: 10px;
		width: 60px;
		max-width: 120px;
		height: 40px;
		margin: 0px auto;
		line-height: 40px;
		background: ${({ theme }) => theme.CQColors.bodyBg};
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		font-size: 14px;
		font-weight: 600;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}
	.title {
		width: 100%;
		position: relative;
		margin: 15px 0px;
		font-weight: 500;
		font-size: 12px;
		line-height: 16px;
		text-transform: capitalize;
		&.largeTitle {
			margin: 10px 0px;
			font-size: 16px;
			line-height: 100%;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
		&.smallTitle {
			margin: 0px;
			font-size: 12px;
			font-weight: 500;
			line-height: 100%;
			color: ${({ theme }) => theme.CQColors.themeColor3};
		}
	}
`;
export const XTheme2GraphExtra = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	font-size: 10px;
	line-height: 20px;
	color: ${({ theme }) => theme.CQColors.themeColor3};
	.value {
		span {
			margin-right: 5px;
			background: #61aa1e;
			padding: 0px 12px;
			line-height: 5px;
			height: 5px;
			border-radius: 10px;
		}
	}
	.count {
		padding-left: 20px;
		span {
			margin-right: 5px;
			background: ${({ theme }) => theme.CQColors.themeColor1};
			padding: 0px 12px;
			line-height: 5px;
			height: 5px;
			border-radius: 10px;
		}
	}
`;

export const XTheme2ScoreGraph = styled.div`
	width: 100%;
	position: relative;
	height: 100%;
	max-height: 80px;
	text-align: center;
	padding: 0px 24px;
	canvas {
		width: 100%;
		height: 100%;
		margin: 0px auto;
	}
`;
